export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f57ae460a9d4a6581bfdf60fa5d5ca8e41da303f9&name=sendEvent!'